import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { App, URLOpenListenerEvent } from "@capacitor/app";
import { PluginListenerHandle } from "@capacitor/core";
import { useConfig } from "../../providers/config";
import { useProductDetailSheetStore } from "../../providers/productDetailSheetStore";

const AppUrlListener = () => {
  const history = useHistory();
  const prevListener = useRef<PluginListenerHandle | null>(null);
  const { siteDomain } = useConfig();

  useEffect(() => {
    if (siteDomain) {
      if (prevListener.current) {
        prevListener.current.remove();
      }

      App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
        const slug = event.url.split(siteDomain).pop();
        if (!slug) return;

        if (slug.startsWith("/product-detail-sheet/")) {
          const id = slug.slice("/product-detail-sheet/".length).split(/[/?#]/)[0];
          if (id) {
            if (history.location.pathname === "/" || history.location.pathname === "/home") {
              history.replace("/home3");
            }
            useProductDetailSheetStore.getState().open(id);
          }
          return;
        }
        history.push(slug);
      }).then((listener) => {
        prevListener.current = listener;
      });
    }
  }, [history, siteDomain]);

  return null;
};

export default AppUrlListener;
